import React from "react";
import "../App.css";
import Netflix from '../pics/services/netflix.png'
import Prime from '../pics/services/prime.png'
import Amazon from '../pics/services/amazon.png'
import iTunes from '../pics/services/itunes.png'
import Apple from '../pics/services/apple.png'
import Google from '../pics/services/google.png'
import Disney from '../pics/services/disney.png'
import Tubi from '../pics/services/tubi.png'
import YouTube from '../pics/services/youtube.png'

function Service({ service }) {

    function getExtraData(name){
        let extraData,
        allExtraData = {
            "Netflix": {
                pic: Netflix,
                displayName: "Netflix"
            },
            "Amazon Prime Video": {
                pic: Prime,
                displayName: "Prime"
            },
            "Disney+": {
                pic: Disney,
                displayName: "Disney+"
            },
            "iTunes": {
                pic: iTunes,
                displayName: "iTunes Store"
            },
            "Google Play": {
                pic: Google,
                displayName: "Google Play"
            },
            "TubiIVAUS": {
                pic: Tubi,
                displayName: "Tubi"
            },
            "Amazon Instant Video": {
                pic: Amazon,
                displayName: "Prime Store"
            },
            "AppleTV+": {
                pic: Apple,
                displayName: 'Apple TV'
            },
            "YouTube Premium": {
                pic: YouTube,
                displayName: 'YouTube'
            },
        }
        extraData = allExtraData[name]
        return extraData
    }  

    return (
        <div className="service">
            <div className="icon-container">
                <a href={service.link}>
                    <img className={service.name + "Pic"} src={getExtraData(service.name).pic} alt={service.name} />
                    <span>{getExtraData(service.name).displayName}</span>
                </a>
            </div>
        </div>
    );
}

export default Service;
